import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
import {withRouter} from "react-router-dom";
import SwitchButton from '../../../../../../components/switch-button';
import Button from '../../../../../../components/button';
import {
	deactivateDirectorySync
} from '../../../../../../../actions/directoryGroupActions';
import {getSharingDetailsPopup} from '../../../../../../../actions/sharingDetailsActions';

function DirectorySyncPopup ({history}) {

	const { t } = useTranslation();
	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const dispatch = useDispatch();

	const [active, setActive] = useState(selectedContactsGroup.activeDirectory);

	const handleClick = () => {
		setActive(!active);
	};

	const handleSwitchSync = () => {
		dispatch(getSharingDetailsPopup([]))
	};

	const handleStopSync = () => {
		dispatch(deactivateDirectorySync(history));
		dispatch(getSharingDetailsPopup([]));
	};

	return (
		<div className="p-4">
			<div className="d-flex align-items-center">
				<h2 className="mr-3">{t("textDirectorySyncAccessDeniedHeader")}</h2>
				<SwitchButton active={active} onClick={handleClick}/>
			</div>
			<p>{selectedContactsGroup.name}</p>
			<div>
				<div className="d-flex align-items-top">
					<ul>
						<li>{t("textDirectoryUserPush")}</li>
						<li>{t("textDirectoryAllDetails")}</li>
					</ul>
				</div>
				<div className="text-center p-3">
					{
						selectedContactsGroup.activeDirectory
						&& !active
						&& <Button onClick={handleStopSync} className="btn-primary">
							{t("textStopSync")}
						</Button>
					}
					{
						selectedContactsGroup.activeDirectory
						&& active
						&& <Button onClick={handleSwitchSync} className="btn-primary">
							{t("okText")}
						</Button>
					}
				</div>
			</div>
		</div>
	)
}

export default withRouter(DirectorySyncPopup);
